import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import Cta from './CTA';

function CaseCard({ headline, image, description, urlText, ctaUrl })
{
  return (
    <div className="flex flex-col shadow-2xl">
      <Link to={"/" + ctaUrl.slug}>
        <GatsbyImage image={getImage(image)} alt={headline} objectFit="cover" className="w-full" />
      </Link>
      <div className="p-8 flex flex-col flex-grow">
        <Link to={"/" + ctaUrl.slug}><h3 className="mb-4 font-medium text-lg">{headline}</h3></Link>
        <p className="font-light text-sm leading-6">{description}</p>
        <div className="flex-grow" />
        <div className="mt-4 text-orange font-semibold hover:text-blue">
          <Link to={"/" + ctaUrl.slug} >{urlText}</Link>
        </div>
      </div>
    </div>
  );
}

function BlueBlock({ title, doings, buttonText, buttonUrl, image })
{
  return (
    <div className="flex flex-col shadow-2xl bg-blue p-8 pb-0 justify-between">
      <h2 className="font-bold text-white text-2xl mb-8">{title}</h2>
      <div className="text-orange text-3xl font-semibold">
        {doings.split("\n").map(doing =>
          <p key={doing} className="mb-2">{doing}</p>
        )}
      </div>
      <Cta title={buttonText} url={buttonUrl} className="bg-orange my-4" />
      {/* <StaticImage src={image} alt={title} className="flex-grow max-h-48" objectFit="contain" objectPosition="50% 100%" /> */}
      <GatsbyImage image={getImage(image)} alt={title} className="flex-grow max-h-48" objectFit="contain" objectPosition="50% 100%" />
    </div>
  )
}

function ContentCases({ cases })
{
  return (
    <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 pb-16">
      {cases.map(caseInfo =>
      {
        if (caseInfo.__typename === "DatoCmsBlockCase")
          return <CaseCard key={caseInfo.id} {...caseInfo} />
        else
          return <BlueBlock key={caseInfo.id} {...caseInfo} />
      })}

    </div>
  );
}

export default ContentCases;